import React from 'react'
import styled from 'styled-components'
import { Title1 } from 'src/Styles/text-styles'
import { ReactComponent as SettingIcon } from 'images/settings-icon.svg'
import { ReactComponent as IPAddressIcon } from 'images/ip-address-icon.svg'
import { ReactComponent as ServerLocationIcon } from 'images/server-location-icon.svg'
import { ReactComponent as SeverHostIcon } from 'images/server-host.svg'
import { ReactComponent as NetworkTypeIcon } from 'images/wi-fi-type.svg'
import { ReactComponent as LocationIcon } from 'images/location-icon.svg'
import { ReactComponent as CrossIcon } from 'images/cross-icon.svg'
import { localize } from 'src/lib/localize'
import { NETWORK_TYPE_MOBILE } from 'src/Common/Constant'
import { AppBrandingSources } from 'src/white-label/AppBrandingSources'
import { APP_BRANDING_KEY } from 'src/white-label/FindWhiteLabel'
import InnerCard from 'src/Home/AdditionalDetail/DesktopView/InnerCard'
import { CardView } from 'src/Component/Card'
import { useHistory } from 'react-router-dom'

const Container = styled.div`
  flex: 1;
  display: flex;
  flexwrap: 'wrap';
  flex-direction: column;
  margin-bottom: 16px;
  pointer-events: none;
`

const OuterContainer = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  margin-bottom: 16px;
`

const Col = styled.div`
  margin: 8px;
  flex-direction: column;
`

const CardHeader = styled.div`
  display: flex;
  justify-content: flex-end;
`

const CloseButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  padding: 4px;
  pointer-events: auto;
`

const Title = styled(Title1)`
  margin-bottom: 16px;
  margin-top: 16px;
  font-weight: 500;
  color: rgba(0, 0, 0, 1);
  @media (min-width: 480px) {
    margin-right: 4px;
  }
  @media (max-width: 480px) {
    margin-right: 4px;
  }
  @media (min-width: 768px) {
    margin-right: 8px;
  }
`

interface Props {
  server_host?: string
  location?: string
  client_ip?: string
  provider_name?: string
  server_location?: string
  network_type?: string
  onClose?: () => void
}

const additionalDetailText = localize('TITLE')('Additional Details')
const closeButtonText = localize('BUTTON')('Close')
const serverHostText = localize('TITLE')('Server Host')
const ipAddressText = localize('TITLE')('IP Address')
const serverLocationText = localize('TITLE')('Server Location')
const providerText = localize('TITLE')('Provider')
const locationText = localize('TITLE')('Location')
const networkTypeText = localize('TITLE')('Network Type')

const MobileView = ({
  server_host,
  location,
  client_ip,
  provider_name,
  server_location,
  network_type,
  onClose,
}: Props) => {
  const history = useHistory()
  const networkTypeDesc =
    network_type === NETWORK_TYPE_MOBILE
      ? localize('LABEL')('Mobile Data')
      : localize('LABEL')('Wi-Fi')

  const handleClose = () => {
    if (onClose) {
      onClose()
    } else {
      history.goBack()
    }
  }

  const appBrandingKey = localStorage.getItem(APP_BRANDING_KEY)
  return (
    <Container>
      <CardView
        style={{
          flex: 1,
          width: '304px',
          maxHeight: '80%',
        }}
      >
        <OuterContainer>
          <CardHeader>
            <CloseButton
              type="button"
              onClick={handleClose}
              aria-label={closeButtonText}
            >
              <CrossIcon width={16} height={16} aria-hidden="true" />
            </CloseButton>
          </CardHeader>
          <Title>{additionalDetailText}</Title>
          {/* <InnerContainer> */}
          <Col>
            {network_type && (
              <InnerCard
                title={networkTypeText}
                description={networkTypeDesc}
                Icon={NetworkTypeIcon}
              />
            )}
          </Col>
          {provider_name && (
            <Col>
              <InnerCard
                title={providerText}
                description={provider_name}
                Icon={SettingIcon}
              />
            </Col>
          )}
          {appBrandingKey !== AppBrandingSources.VODAFONE && location && (
            <Col>
              <InnerCard
                title={locationText}
                description={location}
                Icon={LocationIcon}
              />
            </Col>
          )}
          <Col>
            {client_ip && (
              <InnerCard
                title={ipAddressText}
                description={client_ip}
                Icon={IPAddressIcon}
              />
            )}
          </Col>
          {server_location && (
            <Col>
              <InnerCard
                title={serverLocationText}
                description={server_location}
                Icon={ServerLocationIcon}
              />
            </Col>
          )}
          {server_host && (
            <Col>
              <InnerCard
                title={serverHostText}
                description={server_host}
                Icon={SeverHostIcon}
              />
            </Col>
          )}
          {/* </InnerContainer> */}
        </OuterContainer>
      </CardView>
    </Container>
  )
}

export default MobileView
